module.exports = __webpack_public_path__ + "static/img/campusparty.7d9d5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/campusparty.png
// module id = /arX
// module chunks = 0